import { create } from '@bufbuild/protobuf'

import { useListControls } from '@/api/control.hook'
import { ControlStatus } from '@/gen/controls/v1/control_status_pb'
import {
  ControlCountStatSchema,
  ListControlsRequestSchema,
} from '@/gen/inventory/v1/control_service_pb'
import { OngoingAssessment } from '@/gen/inventory/v1/ongoing_assessment_pb'

import { useFeatureFlagEnabled } from '@/lib/config/featureflag'

export const useControlCountStats = (assessmentId?: OngoingAssessment['id']) => {
  const { data: controls } = useListControls({
    ...create(ListControlsRequestSchema, { assessmentId: assessmentId ?? '' }),
    enabled: !!assessmentId,
  })
  const isAttestedEnabled = useFeatureFlagEnabled('vendor-attested-status').isEnabled

  // Seeded so these buckets render even at zero; any other status still gets a card once it appears,
  // so the cards keep summing to the enabled control count.
  const controlCounts = new Map<ControlStatus, number>([
    [ControlStatus.VALIDATED, 0],
    [ControlStatus.ATTESTED, 0],
    [ControlStatus.GAP, 0],
    [ControlStatus.NO_EVIDENCE, 0],
    [ControlStatus.NOT_APPLICABLE, 0],
  ])
  // An org already carrying attested controls still gets the card, from the loop below.
  if (!isAttestedEnabled) controlCounts.delete(ControlStatus.ATTESTED)

  for (const { status, isEnabled } of controls) {
    if (!isEnabled) continue
    controlCounts.set(status, (controlCounts.get(status) ?? 0) + 1)
  }

  const controlCountStats = Array.from(controlCounts, ([status, count]) =>
    create(ControlCountStatSchema, { status, count }),
  )

  return controlCountStats
}
